/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useMemo } from "react";
import { Banner } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { useSelector } from "react-redux";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import Frame from "../../Frame";
import useGetSearchResultsBound from "../../../../hooks/useGetSearchResultsBound";
import { getSearchDisplayOptions } from "../../../../store/searchResults/selectors";
import { getSearchDisplayOptions as getOBSearchDisplayOptions } from "../../../../store/searchResultsBounds/outboundSelectors";
import { getSearchDisplayOptions as getIBSearchDisplayOptions } from "../../../../store/searchResultsBounds/inboundSelectors";

const NoDirectFlightsBanner = () => {
  const i18n = useI18n();
  const bound = useGetSearchResultsBound();

  const getDisplayOptions = useMemo(() => {
    switch (bound) {
      case "outbound":
        return getOBSearchDisplayOptions;
      case "inbound":
        return getIBSearchDisplayOptions;
      default:
        return getSearchDisplayOptions;
    }
  }, [bound]);

  const displayOptions = useSelector(getDisplayOptions);

  if (!displayOptions?.directFlightsOnlyFilterIgnored) return null;

  return (
    <Frame mb={4}>
      <Banner
        dismissible={false}
        variant="callout"
        startIcon={InfoSignIcon}
        attributes={{ "data-testid": "no_direct_flights_banner" }}
      >
        {i18n.trans(t("flights_search_results_no_direct_flights_options_banner"))}
      </Banner>
    </Frame>
  );
};

export default NoDirectFlightsBanner;
